/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-30 11:39:04
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Tooltip, Icon } from '@shopify/polaris';
import { QuestionMarkMajor } from '@shopify/polaris-icons';

type Props = {
  heading: string,
  tooltipContent: string
};

class TableHeadingCellWithTooltip extends Component<Props> {
  render() {
    const { heading, tooltipContent } = this.props;

    return (
      <span>
        <span>{heading}</span>
        <span className="tooltip">
          <Tooltip
            content={<span className="tooltipContent">{tooltipContent}</span>}
            preferredPosition="above"
            children={<span>text</span>}>
            <Icon source={QuestionMarkMajor} color="base" />
          </Tooltip>
        </span>
      </span>
    );
  }
}

export default TableHeadingCellWithTooltip;
